import { CookingPot, Receipt, SquaresFour, UserCircleGear } from "@phosphor-icons/react";
import { NavLink } from "react-router-dom";
import { useStaffOrders } from "../../context/StaffOrdersContext";

const navItems = [
  { to: "/staff/dispatch", label: "Смена", icon: SquaresFour },
  { to: "/staff/orders", label: "Очередь", icon: Receipt },
  { to: "/staff/kitchen", label: "Кухня", icon: CookingPot },
  { to: "/staff/profile", label: "Профиль", icon: UserCircleGear }
] as const;

export function StaffBottomNav() {
  const { summary } = useStaffOrders();

  return (
    <nav className="pointer-events-none fixed inset-x-0 bottom-0 z-40 flex justify-center px-3 pb-[max(0.9rem,env(safe-area-inset-bottom))] md:absolute md:left-1/2 md:w-full md:max-w-[430px] md:-translate-x-1/2">
      <div className="staff-bottom-nav-surface pointer-events-auto grid w-full max-w-[430px] grid-cols-4 gap-2 rounded-[2rem] border border-white/8 bg-[rgba(20,27,27,0.92)] p-2 shadow-[0_26px_54px_-34px_rgba(0,0,0,0.74)] backdrop-blur-2xl">
        {navItems.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "relative flex min-h-16 flex-col items-center justify-center gap-1 rounded-[1.35rem] px-2 py-2 text-[0.72rem] font-medium tracking-tight transition duration-300 active:scale-[0.98]",
                  isActive
                    ? "bg-[#f2ede4] text-stone-950 shadow-[0_18px_32px_-24px_rgba(242,237,228,0.58)]"
                    : "text-stone-400 hover:bg-white/6 hover:text-stone-100"
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  <div className="relative">
                    <Icon size={20} weight={isActive ? "fill" : "regular"} />
                    {item.to === "/staff/orders" && summary.newCount > 0 ? (
                      <span className="absolute -right-2 -top-2 grid h-5 min-w-5 place-items-center rounded-full bg-amber-300 px-1 text-[0.62rem] font-semibold text-stone-950">
                        {summary.newCount}
                      </span>
                    ) : null}
                  </div>
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}

